(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  const form = document.getElementById('contact_form');
  if(form !== null ){
    let form_action = form.getAttribute('action');
    let form_action_wo_hash = form_action.substring(0,form_action.indexOf('#'));
    form.setAttribute('action', form_action_wo_hash);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    check_emi();

    // Manejador de evento para el cambio en select de EMI
    document.addEventListener('change', function (event) {
      if (event.target.matches('select[name="emi_select"]')) {
        check_emi();
      }
    });

    // Manejador de evento para el botón "más contenido"
    document.addEventListener('click', function (event) {
      if (event.target.matches('.more-content')) {
        document.querySelectorAll('.custom-hide-show').forEach(function (element) {
          element.classList.add('active-content');
        });
        document.querySelectorAll('.less-content').forEach(function (element) {
          element.classList.remove('custom-hidden');
        });
        event.target.classList.add('custom-hidden');
      }
    });

    // Manejador de evento para el botón "menos contenido"
    document.addEventListener('click', function (event) {
      if (event.target.matches('.less-content')) {
        document.querySelectorAll('.custom-hide-show').forEach(function (element) {
          element.classList.remove('active-content');
        });
        document.querySelectorAll('.more-content').forEach(function (element) {
          element.classList.remove('custom-hidden');
        });
        event.target.classList.add('custom-hidden');
      }
    });
  });

  function check_emi() {
    const priceElement = document.querySelector('span.h3.current-price.theme-money');
    const price_text = parseFloat(priceElement.getAttribute('origin_price')) / 100;
    const select_element = document.querySelector('select[name="emi_select"]');
    const selected_val = select_element ? select_element.value : 1;
    const emi_val = parseFloat(price_text) / parseFloat(selected_val);

    const formated_val = emi_val
      .toString()
      .replace(/(?!\.)\D/g, '')
      .replace(/(?<=\..*)\./g, '')
      .replace(/(?<=\.\d\d).*/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    document.querySelectorAll('.divide_val').forEach(function (element) {
      element.textContent = parseInt(formated_val);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const slick_details = {
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('#prev-arrow'),
            nextArrow: $('#next-arrow'),
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          };
          $('.product-recommendations .product-recommendations__slider').slick(slick_details);      
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-similars"] && !Shopify.designMode) return;
  try {
    
if($('.product-similars__slider').children().length > 0){
  const slick_details = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('#prev-arrow-2'),
    nextArrow: $('#next-arrow-2'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };
  
  // Add margin to the slides
  $('.product-similars__slider').find('.slick-slide').css('margin', '0 20px'); // Adjust the margin value as needed

  $('.product-similars__slider').slick(slick_details);
}


  } catch(e) { console.error(e); }
})();
})();
